<template>
    <!-- Modal Update Remove -->
    <b-modal id="modal-remove-paypal-ba"
        centered
        :title="title()"
        @ok="removePaypalBA"
        :ok-variant="readyToSubmit"
        :ok-disabled="disableOk"
        :ok-title="okButtonLabel()"
        @shown="modalDidShow"
        cancel-variant="link"
        :lazy="true"
        ref="modalPaypalBARemove">
        <div class="row">
            <div class="col px-6 py-2">
                <form>
                    <div class="form-row" v-if="this.clientHasActivePaypalBA">
                        <div class="col text-center">
                            <img src="/img/logo-paypal.gif" class="pb-4"/>
                            <p>This will unlink your PayPal account with Servers Australia.</p>
                            <input type="checkbox" v-model="confirmTicked">
                            <label>Yes, Unlink my PayPal Account</label>
                        </div>
                    </div>
                    <div class="form-row" v-else>
                        <div class="col">
                            <div class="col">
                                <p class="text-center">We're having an issue right now. Please call us on 1300 788 862.</p>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { required, minLength, maxLength, numeric } from 'vuelidate/lib/validators';
export default {
    props: [
        'baStarted',
        ],
    data() {
        return {
            confirmTicked: false
        }
    },
    validations: {
        confirmTicked: {
            required
        }
    },
    methods:{
        okButtonLabel() {
            return this.clientHasActivePaypalBA ? 'Continue' : 'Continue';
        },
        title() {
            return 'Unlink your PayPal Account';
        },
        modalDidShow() {

        },
        removePaypalBA() {
            // Make API call to cancel BA
            this.$swal({
                title: 'Removing your Paypal Billing Agreement',
                text: "Please wait...",
                imageUrl: "/img/spinner-circle-120.gif",
                showConfirmButton: false,
                allowOutsideClick: false
            });
            //using setTimeout to simulate ajax request
            setTimeout(() => {
                //Axios request
                let request = {
                    data: { }
                };
                axios.delete('/api/billing/paypal-ba', request)
                .then(response => {
                    if(response.data.status == 'success') {
                        /** Successful - populate last four cc details */
                        this.$store.commit('paypalActiveBAOnFile', false);
                        this.confirmTicked = false;
                        this.$v.$reset();
                        this.$swal.close();
                        this.modalHide('modalPaypalBARemove');
                    } else {
                        this.$swal({
                            type:'error',
                            title: 'There seems to be a problem',
                            html: 'There has been a problem with Cancelling your Billing Agreement. Please try again.',
                            buttonsStyling: false,
                            confirmButtonText: 'Close',
                            confirmButtonClass: 'btn btn-danger'
                        });
                    }
                    /** Clear Validation */
                    // this.clearDetails();
                })
                .catch(error => {
                    /** Create message form response */
                    let message = 'There has been a problem Cancelling your Billing Agreement.<br /><br />';
                    _.forIn(error.response.data.errors, function(value, key) {
                        message += value+'<br />';
                    });
                    this.$v.$reset();
                    this.modalHide('modalPaypalBARemove');
                    this.$swal({
                        type:'error',
                        title: 'There seems to be a problem',
                        html: message,
                        buttonsStyling: false,
                        confirmButtonText: 'Close',
                        confirmButtonClass: 'btn btn-danger'
                    });
                    // this.clearDetails();
                });
            }, 1000);  //Slow it down slightly


        }
    },
    computed: {
        readyToSubmit() {
            return (this.confirmTicked && this.clientHasActivePaypalBA) ? 'success' : 'light';
        },
        disableOk() {
            return (this.confirmTicked && this.clientHasActivePaypalBA) ? false : true;
        }
    }
}
</script>
